import type { PublishedEstimation } from '@tempo-io/roadmap-dto';
import type { Estimation } from '@/common/api/types/estimationScheme';
import { useEstimationsQuery } from '@/common/queries/useGetEstimationScheme';
import { commonQueryKeys } from '@/common/queryKeys/common';
import { usePublishedContext } from '@/features/views/components/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/features/views/components/published/usePublishedSnapshotQuery';

function mapPublishedEstimation(e: PublishedEstimation): Estimation {
  return {
    id: e.id,
    label: e.label,
    estimationSchemeId: e.estimationSchemeId,
    organizationId: '',
    highEffort: null,
    lowEffort: null,
    createdAt: '',
    updatedAt: '',
    createdBy: '',
    updatedBy: '',
    archivedAt: null,
  };
}

export const useEstimationsQueryWithPublished = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const estimationsQuery = useEstimationsQuery({ enabled: !isPublished && enabled });

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: [...commonQueryKeys.estimationSchemes.all(), 'estimations'],
    getSnapshot: () =>
      publishedContext ? publishedContext.estimations.map(mapPublishedEstimation) : undefined,
  });

  return isPublished ? publishedQuery : estimationsQuery;
};
